const settingCategories = [
  {
    id: 'intake',
    name: 'Intake',
    subCategories: [
      { id: 'localization', name: 'Localization & Language' },
      { id: 'pageContent', name: 'Page Content' },
      { id: 'logos', name: 'Logos' },
      { id: 'theme', name: 'Theme Colors' },
      { id: 'behavior', name: 'Intake Behavior' },
      { id: 'message', name: 'SMS Delivery Configuration' },
      { id: 'timing', name: 'Timing & Scheduling' },
    ],
  },
  {
    id: 'hxManager',
    name: 'HxManager',
    subCategories: [
      { id: 'general', name: 'General' },
      { id: 'sms', name: 'SMS Configuration' },
      { id: 'llm', name: 'LLM/AI' },
      { id: 'medscheck', name: 'Medscheck' },
      { id: 'scribe', name: 'Scribe' },
    ],
  },
  {
    id: 'api',
    name: 'Api',
    subCategories: [
      { id: 'accuro', name: 'Accuro' },
      { id: 'canvas', name: 'Canvas' },
      { id: 'epic', name: 'Epic' },
      { id: 'notification', name: 'Notification' },
      { id: 'pushToEndpoint', name: 'PushToEndpoint' },
      { id: 'pcc', name: 'PointClickCare' },
      { id: 'sftp', name: 'SFTP' },
      { id: 'athena', name: 'Athena' },
      { id: 'advancedMD', name: 'Advanced MD' },
      { id: 'ecw', name: 'ECW' },
      { id: 'telus', name: 'Telus' },
    ],
  },
  { id: 'geography', name: 'Geography' },
  { id: 'medical', name: 'Medical' },
];

export default settingCategories;
